<template>
	<v-row class="fill-height" justify="center" align="start">
		<v-col cols="12">
			<div class="d-flex justify-space-between py-5">
				<div class="d-flex cursor-pointer" @click="$router.go(-1)">
					<v-icon>mdi-chevron-left</v-icon>
					<div class="ml-2">Back</div>
				</div>
				<div>
					<span>New to Homify?</span>
					<span
						class="text-decoration-underline secondary--text ml-2 cursor-pointer"
						@click="goToPage('auth.register')"
						>Sign Up</span
					>
				</div>
			</div>
		</v-col>
		<v-col cols="11" md="8" v-if="isLinkSent && !isVerified">
			<div>
				<p class="text-h4 font-weight-bold">
					{{
						isVerifying ? "Verifying email for your" : "Verify email for your"
					}}
					<span class="secondary--text text-h4 font-weight-bold homify-title"
						>Homify</span
					>
					Account
				</p>
				<p class="mb-6" v-if="!isVerifying">
					A link has been sent to your mail to help verify your account.
				</p>
				<p class="mb-6" v-if="isVerifying">Please wait...</p>
				<v-divider />

				<v-btn
					block
					:disabled="isVerifying"
					:loading="isLoading || isVerifying"
					depressed
					color="primary"
					class="py-7 mt-10 text-none"
					@click="isLinkSent = false"
					>Resend Verification</v-btn
				>
			</div>
		</v-col>
		<v-col cols="11" md="8" v-if="!isLinkSent && !isVerified">
			<div>
				<p class="text-h4 font-weight-bold">
					Verify email for your
					<span class="secondary--text text-h4 font-weight-bold homify-title"
						>Homify</span
					>
					Account
				</p>
				<p class="mb-6">
					A link has sent to your mail to help verify your account.
				</p>
				<v-divider />

				<div class="mb-2 mt-10">Email Address*</div>
				<v-text-field
					@keyup.enter="!isDisabled ? $refs.verifyAction.$el.click() : ''"
					:rules="[rules.required, rules.email]"
					v-model="form.email"
					placeholder="Enter email Address"
					outlined
				></v-text-field>

				<small v-if="isLinkSent" class="primary--text">
					A magic link has been sent to your mail to help verify your email.
				</small>

				<v-btn
					ref="verifyAction"
					block
					:loading="isLoading"
					depressed
					color="primary"
					:disabled="isDisabled"
					class="py-7 mt-10 text-none"
					@click="resendEmailVerification"
					>Submit</v-btn
				>
			</div>
		</v-col>
		<v-col cols="11" md="8" v-if="isVerified">
			<div>
				<p class="text-h4 font-weight-bold">
					Verified email for your
					<span class="secondary--text text-h4 font-weight-bold homify-title"
						>Homify</span
					>
					Account successfully
				</p>
				<p class="mb-6">You can proceed to log in.</p>
				<v-divider />

				<v-btn
					block
					:loading="isLoading"
					depressed
					color="primary"
					:disabled="isDisabled"
					class="py-7 mt-10 text-none"
					@click="goToPage('auth.login')"
					>{{ isVerified ? "Login" : "Submit" }}</v-btn
				>
			</div>
		</v-col>
		<v-col cols="12">
			<div class="d-flex justify-center mt-auto" v-if="!isVerified">
				<div />
				<div>
					<span>Already have an account?</span>
					<span
						class="text-decoration-underline secondary--text ml-2 cursor-pointer"
						@click="goToPage('auth.login')"
						>Login</span
					>
				</div>
			</div>
		</v-col>
	</v-row>
</template>

<script>
	import { mapState } from "vuex";
	import { AuthService } from "@/services/index.js";

	export default {
		data() {
			return {
				rememberMeCheckbox: false,
				isLoading: false,
				isLinkSent: true,
				isVerifying: false,
				isVerified: false,
				form: {
					email: "",
				},
				rules: {
					required: (value) => !!value || "Required.",
					counter: (value) => value.length <= 20 || "Max 20 characters",
					email: (value) => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return pattern.test(value) || "Invalid e-mail.";
					},
				},
			};
		},
		computed: {
			...mapState(["userObj"]),
			isDisabled() {
				return this.form?.email?.length == 0;
			},
		},
		methods: {
			goToPage(name) {
				this.$router.push({ name });
			},
			async resendEmailVerification() {
				try {
					this.isLoading = true;
					let res = await AuthService.resendEmailVerification(this.form.email);
					this.$store.commit("openSnackbar", res.message);
					this.isLoading = false;
				} catch (error) {
					this.isLoading = false;
					// throw error;
				}
			},
			async verifyEmail() {
				try {
					this.isVerifying = true;
					let token = this.$route.params.token;
					let result = await AuthService.verifyEmail(token);

					this.$store.commit("openSnackbar", result.message);

					this.isVerifying = false;
					this.isVerified = true;
				} catch (error) {
					this.isVerifying = false;
				}
			},
			checkIfVerified() {
				let result = this.userObj.emailverified;

				if (result) {
					this.$router.replace({ name: "dashboard.index" });
				}
			},
		},
		mounted() {
			this.checkIfVerified();
			this.form.email = this.$route.query.email;

			if (this.$route.params.token) {
				this.verifyEmail();
			}
		},
	};
</script>
